<template>
  <generic-modal :title="$t('movement type')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('sale')"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-cubes"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("effect in inventory") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.effect">
                  <option value="increment">{{ $t("increment") }}</option>
                  <option value="decrement">{{ $t("decrement") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-rounded"
        @click="$refs.generic_modal.close_modal"
      >
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, get, post, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.effect;
    },
  },
  methods: {
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(movment_type_uuid) {
      let v = this;
      v.set_initial_state();
      get("/inventory/movement_type", { uuid: movment_type_uuid })
        .then((mvmnt_type) => {
          v.meta = mvmnt_type;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      if (!data.uuid) {
        put("/inventory/movement_type", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        post("/inventory/movement_type", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        name: "",
        effect: "",
        settings: {},
      };
      v.error = "";
    },
    set_movement_type(value, b, a) {
      // let v = this;
      console.log("value", value, b, a);
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
